import * as React from 'react';
import useGetAppointmentPayments from '../../hooks/appointments/useGetAppointmentPayments';
import TransactionsList from '../transactions/TransactionsList';
import { convertPaymentsToTransactions } from '../../helpers/payments';
import { Appointment } from '../../interfaces';

export default function TransactionsSection({
  appointment,
}: {
  appointment: Appointment;
}) {
  const { payments, isFetching } = useGetAppointmentPayments(appointment);

  const cleanedPayments = React.useMemo(
    () => convertPaymentsToTransactions(payments, { appointment }),
    [payments, appointment],
  );

  return (
    <TransactionsList transactions={cleanedPayments} isLoading={isFetching} />
  );
}
